package net.gorillagroove.notification

import net.gorillagroove.api.PlaylistId
import net.gorillagroove.api.UserNotificationId
import net.gorillagroove.track.Track
import net.gorillagroove.util.Formatter.toTimeAgoString
import net.gorillagroove.util.Instant

class UserNotification(
    val id: UserNotificationId,
    val message: String,
    val read: Boolean,
    val createdAt: Instant,
    val updatedAt: Instant,
    val type: UserNotificationType,
    val data: UserNotificationData,
) {
    val createdAgoString: String get() = createdAt.toTimeAgoString()
}

data class PlaylistNotificationData(
    override val notificationIds: List<UserNotificationId>,
    val playlistId: PlaylistId,
) : UserNotificationData

data class TrackNotificationData(
    override val notificationIds: List<UserNotificationId>,
    val track: Track,
) : UserNotificationData

data class NoActionNotificationData(override val notificationIds: List<UserNotificationId>) : UserNotificationData

interface UserNotificationData {
    val notificationIds: List<UserNotificationId>
}
